import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'

import LoginPage from './pages/LoginPage'
import DashboardPage from './pages/DashboardPage'
import EmployeesPage from './pages/EmployeesPage'
import DivisionsPage from './pages/DivisionsPage'
import ContractsPage from './pages/ContractsPage'
import CreateContractPage from './pages/CreateContractPage'
import ApprovePage from './pages/ApprovePage'
import SignPage from './pages/SignPage'
import QRCodePage from './pages/QRCodePage'
import ContractDetailPage from './pages/ContractDetailPage'
import MayorPage from './pages/MayorPage'
import UsersPage from './pages/UsersPage'
import ClerkPage from './pages/ClerkPage'
import RegistrationTrackingPage from './pages/RegistrationTrackingPage'
import ReportPage from './pages/ReportPage'
import AdminPage from './pages/AdminPage'
import EmployeeHistoryPage from './pages/EmployeeHistoryPage'
import VerifyPage from './pages/VerifyPage'
import EmployeeRegistrationPage from './pages/EmployeeRegistrationPage';
import RegistrationStatusPage from './pages/RegistrationStatusPage'
import ChangePasswordPage from './pages/ChangePasswordPage'



// ใน Routes:


const HRRoute = ({ children, allowWitness = false }) => {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (user.role === 'hr' && user.is_witness === true && !allowWitness) return <Navigate to="/approve" replace />
  if (user.role === 'mayor') return <Navigate to="/mayor" replace />
  if (user.role === 'clerk') return <Navigate to="/clerk" replace />
  if (user.role === 'admin') return <Navigate to="/admin" replace />
  return children
}

const MayorRoute = ({ children }) => {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (user.role !== 'mayor') return <Navigate to="/dashboard" replace />
  return children
}

const ClerkRoute = ({ children }) => {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (user.role !== 'clerk') return <Navigate to="/dashboard" replace />
  return children
}

const AdminRoute = ({ children }) => {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (user.role !== 'admin') return <Navigate to="/dashboard" replace />
  return children
}

const PublicRoute = ({ children }) => {
  const { user } = useAuth()
  if (!user) return children
  if (user.role === 'mayor') return <Navigate to="/mayor" replace />
  if (user.role === 'admin') return <Navigate to="/admin" replace />
  if (user.role === 'clerk') return <Navigate to="/clerk" replace />
  if (user.role === 'hr' && user.is_witness === true) return <Navigate to="/approve" replace />
  return <Navigate to="/dashboard" replace />
}

function DefaultRedirect() {
  const { user } = useAuth()
  if (!user) return <Navigate to="/login" replace />
  if (user.role === 'mayor') return <Navigate to="/mayor" replace />
  if (user.role === 'clerk') return <Navigate to="/clerk" replace />
  if (user.role === 'admin') return <Navigate to="/admin" replace />
  if (user.role === 'hr' && user.is_witness === true) return <Navigate to="/approve" replace />
  return <Navigate to="/dashboard" replace />
}

function AppRoutes() {
  const { user } = useAuth()
  const location = useLocation()
  if (user?.must_change_password) return (
    <Routes>
      <Route path="/change-password" element={<ChangePasswordPage />} />
      <Route path="*" element={<Navigate to="/change-password" replace />} />
    </Routes>
  )
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/sign/:token" element={<SignPage />} />
      <Route path="/verify/:year/:number" element={<VerifyPage />} />
      <Route path="/register" element={<EmployeeRegistrationPage />} />
      <Route path="/register/status" element={<RegistrationStatusPage />} />
      <Route path="/change-password" element={user ? <ChangePasswordPage /> : <Navigate to="/login" replace />} />

      <Route path="/dashboard" element={<HRRoute><DashboardPage /></HRRoute>} />
      <Route path="/employees" element={<HRRoute><EmployeesPage /></HRRoute>} />
      <Route path="/employees/:id/history" element={<HRRoute><EmployeeHistoryPage /></HRRoute>} />
      <Route path="/admin/employees" element={<AdminRoute><EmployeesPage /></AdminRoute>} />
      <Route path="/divisions" element={<HRRoute><DivisionsPage /></HRRoute>} />
      <Route path="/contracts" element={<HRRoute><ContractsPage /></HRRoute>} />
      {/* Start a fresh form on navigation, including a click on the current create menu. */}
      <Route path="/contracts/create" element={<HRRoute><CreateContractPage key={location.key} /></HRRoute>} />
      <Route path="/contracts/:id/qr" element={<HRRoute><QRCodePage /></HRRoute>} />
      <Route path="/contracts/:id" element={<HRRoute><ContractDetailPage /></HRRoute>} />
      <Route path="/approve" element={<HRRoute allowWitness><ApprovePage /></HRRoute>} />

      <Route path="/mayor" element={<MayorRoute><MayorPage /></MayorRoute>} />
      <Route path="/tracking" element={<HRRoute><ClerkPage /></HRRoute>} />
      <Route path="/clerk" element={<ClerkRoute><ClerkPage /></ClerkRoute>} />
      <Route path="/clerk/registrations" element={<ClerkRoute><RegistrationTrackingPage /></ClerkRoute>} />
      <Route path="/users" element={<AdminRoute><UsersPage /></AdminRoute>} />
      <Route path="/reports" element={<HRRoute><ReportPage /></HRRoute>} />
      <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
      <Route path="/" element={<DefaultRedirect />} />
      <Route path="*" element={<DefaultRedirect />} />
    </Routes>
  )
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  )
}

export default App
